import GausiumMapPreviewOverlay, {
  type GausiumMapPreviewOverlayProps,
  type GausiumMapRobotMarker,
  type GausiumMapTrailPoint,
} from 'components/GausiumMapPreviewOverlay/GausiumMapPreviewOverlay'

export type FloorMapRobotMarker = GausiumMapRobotMarker
export type FloorMapTrailPoint = GausiumMapTrailPoint
export type FloorMapPreviewOverlayProps = GausiumMapPreviewOverlayProps

const FloorMapPreviewOverlay = (props: FloorMapPreviewOverlayProps) => {
  return <GausiumMapPreviewOverlay {...props} />
}

export default FloorMapPreviewOverlay
